import script from "./RoomSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomSlider.vue?vue&type=script&setup=true&lang=js"

import "./RoomSlider.vue?vue&type=style&index=0&id=03be3f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03be3f46"]])

export default __exports__